import * as Primitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { useSurfaceTheme, useSurfaceThemeClasses } from "./surface-theme";
import { useDialogContainer } from "./dialog";

export const Root = Primitive.Root;
export const Trigger = Primitive.Trigger;
export const Anchor = Primitive.Anchor;
export const Close = Primitive.Close;
export const Arrow = Primitive.Arrow;
export function Portal({ container, ...props }: ComponentProps<typeof Primitive.Portal>) {
  const dialogContainer = useDialogContainer();
  // 在 Dialog 内打开时挂进 Dialog 内容，使其跟随 fieldset 禁用与层叠语义。
  return <Primitive.Portal container={container ?? dialogContainer} {...props} />;
}
export function Content({ className, sideOffset, collisionPadding, ...props }: ComponentProps<typeof Primitive.Content>) {
  const showcase = useSurfaceTheme() !== "default";
  const theme = useSurfaceThemeClasses();
  return <Primitive.Content data-slot="popover-content" sideOffset={sideOffset ?? (showcase ? 8 : 6)} collisionPadding={collisionPadding ?? (showcase ? 12 : undefined)} className={cn("z-50 max-h-[var(--radix-popover-content-available-height)] max-w-[calc(100vw-2rem)] rounded-lg border border-border bg-popover text-popover-foreground shadow-md outline-none", showcase && "backdrop-blur-xl", theme, className)} {...props} />;
}
